import React from 'react';
import {View} from 'react-native';

import Locale from './../../Locale';
import {Layout, Navbar} from './../../Screen';
import {Form, Heading1, Button} from './../../Form';
import AHIFScreen from './AHIFScreen';
import IntroParagraph from './../components/IntroParagraph';
import ProductEdges from './../components/ProductEdges';
import PlanType from './../components/PlanType';
import DiscountInput from './../components/DiscountInput';
import LeafletAndProvision from './../components/LeafletAndProvision';

export default class AHIFScreen1 extends AHIFScreen {
  componentDidMount() {
    this.initialize();
  }

  render() {
    const {policy, ahif, payment} = this.state.insuranceProduct;

    let leaflet;
    switch (Locale.getLocale()) {
      case Locale.enUS:
        leaflet = 'Product_leaflet_AHI_eng.pdf';
        break;
      case Locale.zhHK:
        leaflet = 'Product_leaflet_AHI_chi.pdf';
        break;
    }

    const provision = 'Product_Provision_AHI.pdf';

    return (
      <Layout alert={this.state.alert}>
        <Navbar
          screen={this}
          title={Locale.text.getAQuote}
        />

        {Locale.text.ahiInsurance}
        {''}

        <View style={Layout.container}>
          <Form>
            <Heading1>
              {Locale.text.ahiInsurance}
            </Heading1>

            <IntroParagraph>
              {Locale.text.ahiInsuranceProtectorIntroParagraph}
            </IntroParagraph>

            <ProductEdges>
              {Locale.text.ahiInsuranceProtectorProductEdge1}
              {Locale.text.ahiInsuranceProtectorProductEdge2}
              {Locale.text.ahiInsuranceProtectorProductEdge3}
            </ProductEdges>

            <LeafletAndProvision
              noPremiumRates={true}
              screen={this}
              leaflet={leaflet}
              provision={provision}
            />

            <PlanType
              options={this.premiumPlanOptions}
              value={ahif.premiumPlan}
              onChange={(premiumPlan) =>
                this.updateAHI({premiumPlan})}
            />

            {/* <DiscountInput
              cozy
              promotionCode={payment.promotionCode}
              businessEmail={policy.businessEmail}
              directCustomer={this.state.initialized &&
                !this.state.agent && !this.state.broker}
              onChange={({promotionCode, businessEmail}) => {
                this.updatePayment({promotionCode});
                this.updatePolicy({businessEmail});
              }}
              messages={this.state.messages.discount}
            /> */}

            <Button
              disabled={this.state.waiting}
              onPress={() => this.getQuote('ahif2')}
            >
              {Locale.text.getAQuote}
            </Button>
          </Form>
        </View>
      </Layout>
    );
  }
}
